import React from 'react';

import Section from '../Section';
import Container from '../Container';
import MainTitle from '../MainTitle';
import MainParagraph from '../MainParagraph';
import Members from '../Members';
import Meetups from '../Meetups';
import SectionTitle from '../SectionTitle';
import { AnimationText, AnimationAppearLeft } from '../Animation';

const Content: React.FC = () => (
  <>
    <Section id="home" bgImage="linear-gradient(to right, #175AA5,#267ABD)">
      <Container>
        <AnimationAppearLeft>
          <MainTitle>Dev Seridó</MainTitle>

          <MainParagraph>
            <AnimationText text="Somos uma comunidade que respira e compartilha o amor pela tecnologia." />
          </MainParagraph>
        </AnimationAppearLeft>
      </Container>
    </Section>

    <Section id="members">
      <Container>
        <AnimationAppearLeft>
          <SectionTitle>Membros</SectionTitle>
          <Members />
        </AnimationAppearLeft>
      </Container>
    </Section>

    <Section id="meetups">
      <Container>
        <AnimationAppearLeft>
          <SectionTitle>Meetups</SectionTitle>
          <Meetups />
        </AnimationAppearLeft>
      </Container>
    </Section>
  </>
);

export default Content;
